export const PRODUCT_DETAILS_PANEL_MODE = {
  product: 'product',
  aggregated: 'aggregated',
};

export function getProductDetailsPanelMode({
  isMainApp,
  hasAssets,
  productSelectionCount,
  activeProduct,
  isBulkMediaView,
}) {
  if (!isMainApp) return null;

  if (productSelectionCount >= 2) {
    return PRODUCT_DETAILS_PANEL_MODE.aggregated;
  }

  if (productSelectionCount === 1) {
    return PRODUCT_DETAILS_PANEL_MODE.product;
  }

  if (isBulkMediaView) return PRODUCT_DETAILS_PANEL_MODE.aggregated;
  if (hasAssets) return null;

  if (activeProduct) {
    return PRODUCT_DETAILS_PANEL_MODE.product;
  }

  return null;
}

export default getProductDetailsPanelMode;
